import { makeStyles } from '@material-ui/core';
import hexToRgb from '../../../helpers/ui/coloringHelper';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  buttonDiv: {
    color: theme.palette.white.main,
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    minWidth: 200,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: `rgba(${hexToRgb(theme.palette.black.main)}, 0.3)`,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    '&:active': {
      backgroundColor: `rgba(${hexToRgb(theme.palette.black.main)}, 0.3)`,
    },
  },
  customHover: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.black.main)}, 0.3)`,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  menuItem: {
    height: 50,
    color: theme.palette.black.main,
    paddingLeft: 20,
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
    },
  },
  menuBox: {
    boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.1), 0px -5px 5px -3px rgba(0, 0, 0, 0.1)',
    backgroundColor: theme.palette.white.main,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  subMenuBox: {
    cursor: 'pointer',
  },
  childArrowIcon: {
    fontSize: 20,
    color: theme.palette.primary.main,
    marginLeft: 5,
  },
  expandIcon: {
    marginLeft: 10,
    color: theme.palette.white.main,
    transition: 'transform .2s ease',
    fontSize: '30px !important',
  },
  popper: {
    zIndex: 1302,
  },
}));

export default useStyles;
